import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";

export class NiceSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  code?: string;
  limit?: number;
  carrier?: Array<string>;
  page?: number;
  phoneNumber?: string;
  pagination?: boolean;
  status?: number;
  numberType?: string;
  simType?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  note?: string;
  store?: string;
  staff?: string;
  order?: string;
  isOnlyStore?: string;

  constructor(data?: {
    code?: string;
    limit?: number;
    carrier?: Array<string>;
    page?: number;
    phoneNumber?: string;
    pagination?: boolean;
    simType?: string;
    status?: number;
    numberType?: string;
    service?: string;
    created?: Record<string, unknown>[];
    fromDate?: string;
    toDate?: string;
    note?: string;
    store?: string;
    staff?: string;
    order?: string;
    isOnlyStore?: string;
  }) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.simType = data?.simType;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.numberType = data?.numberType;
    this.note = data?.note;
    this.created = data?.created;
    this.store = data?.store;
    this.order = data?.order;
    this.staff = data?.staff;
    this.isOnlyStore = data?.isOnlyStore;
  }
}
